<template>
    <div class="size">
      <div class="boxsize1">
        <div class="catalogue">
          <!-- <div class="catalogue1" id="catalogue1" @click="contract">客户信息</div>
          <div class="catalogue2" id="catalogue2" @click="prospectus">投资画像</div> -->
          <div class="catalogue1" id="catalogue1" @click="prospectus">客户信息</div>
          <div class="catalogue2" id="catalogue2" @click="contract">投资画像</div>
          <div class="chart">
              <div >
                <v-chart class="echart1" :options="visitTrend"></v-chart>
              </div>
          </div>
        </div>
      </div>
      
      <div class="boxsize1">
        <div class="catalogue">
          <div class="catalogue4" ><span class="titlecss">产品推荐</span></div>
          <div>
            <div class="contro1">
              <div class="contro2">
                <div class="box1">
                  <div class="box12">
                    <span class="ttcss">理财</span>
                  </div>
                </div>
                <div class="box2">
                  <span class="font1">瑞盈精选组合人民币理财… </span>
                </div>
                <div class="box3">
                  <span class="font2">推送</span>
                </div>
              </div>
              <div class="contro2">
                <div>
                  <span class="font3">[5.2%] [中等风险] [3年] [20.23万起]</span>
                </div>
              </div>
            </div>
            


            <div class="contro1">
               <span class="">到底了</span>
            </div>

          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  name: "flow",
  mounted(){
      // this.getUserMessage();
      this.getecharts();
    	},
  data() {
    return {
      judge: true,
      bank: "中国工商银行股份有限公司",
      // name: "何婷婷",
      level:3,
      // phone:15536775771,
      // customerID:20081738090,
      businesstype:"综合业务",
      // openbankname:"北京银行知春路分行",
      userMassage:{
        id:'',
        name: '',
        openBankname:'',
        phone:'',
        customerId:'',
      },
      visitTrend:{},
    };
  },
  methods:{

      getUserMessage(){
        const parames = {
          data: {
            phone:"15536775771", 
          },
        };
        this.$_post(this.$API.getUserMassage, parames).then(res => {
            if(res.errorCode=='E00000'){
              console.log(res);
              this.userMassage=res.data.info;
              this.level = res.data.info.column2; 
            }
          
        });
      },
      goto(){
       alert("暂未开放")
        return;
      },
      contract(){
         this.judge=true
         this.switchover()
      },
      prospectus (){
          this.judge=false
          this.switchover()
          this.$router.push({path:'/rightvue'})
      },
      switchover (){
          let a = document.getElementById("catalogue1")    
          let b = document.getElementById("catalogue2")
          if(this.judge){
              b.style.fontWeight="500"
              a.style.fontWeight="bold"
              a.style.fontFamily="PingFangSC, PingFangSC-Medium"
              b.style.fontFamily="PingFangSC, PingFangSC-Light"
              a.style.borderBottom="5px solid #000"
          }else{
              a.style.fontWeight="500"
              b.style.fontWeight="bold"
              b.style.fontFamily="PingFangSC, PingFangSC-Medium"
              a.style.fontFamily="PingFangSC, PingFangSC-Light"
              a.style=" border-bottom:1px solid "
          }
      },
      getecharts(){
        this.visitTrend = {
            title: {
                // text: '基础雷达图',
                left: 'center',
            },
            tooltip: {},
            legend: {
                // data: ['预算分配（Allocated Budget）', '实际开销（Actual Spending）']
            },
            radar: {
                name: {
                    textStyle: {
                        color: '#999',
                        backgroundColor: '#fff',
                        borderRadius: 1,
                        padding: [1, 3]
                    }
                },
                indicator: [
                    { name: '投资风险', max: 6500},
                    { name: '投资收益', max: 16000},
                    { name: '投资金额', max: 30000},
                    { name: '投资种类', max: 38000},
                    { name: '投资期限111', max: 52000},
                ]
            },
            series: [{
                // name: '预算 vs 开销（Budget vs spending）',
                type: 'radar',
                data: [
                    {
                        value: [4300, 10000, 28000, 35000, 50000],
                        // name: '预算分配（Allocated Budget）'
                    },
                    {
                        value: [5000, 14000, 28000, 31000, 42000],
                        // name: '实际开销（Actual Spending）'
                    }
                ]
            }]
        };;
      }
  },


};
</script>
<style  scoped>
* {
  margin: 0;
}
.chart {
    /* display: flex;
    align-items: center;
    justify-content: space-between; */
    width: 292px;
    height: 290px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    border-radius: 5px;
  }
.echart1{
  width: 300px;
  height: 300px;
}
.box1{
  width: 28px;
  /* height: 12px; */
  font-size: 10px;
  font-family: SourceHanSansCN, SourceHanSansCN-Normal;
  font-weight: Normal;
  text-align: left;
  color: #ffffff;
  line-height: 10px;
  letter-spacing: 0px;
}
.box12{
  width: 28px;
  height: 16px;
  background: #3981f1;
  border-radius: 2px;
}
.box2{
  font-size: 10px;
  font-family: SourceHanSansCN, SourceHanSansCN-Normal;
  font-weight: Normal;
  text-align: left;
  color: #ffffff;
  line-height: 10px;
  letter-spacing: 0px;
}
.box3{
  width: 28px;
  justify-content:  flex-end;
  /* height: 12px; */
  font-size: 10px;
  font-family: SourceHanSansCN, SourceHanSansCN-Normal;
  font-weight: Normal;
  text-align: left;
  color: #ffffff;
  line-height: 10px;
  letter-spacing: 0px;
}
.ttcss{
  width: 28px;
  height: 12px;
  font-size: 10px;
  font-family: SourceHanSansCN, SourceHanSansCN-Normal;
  font-weight: Normal;
  text-align: left;
  color: #ffffff;
  line-height: 10px;
  letter-spacing: 0px;
}
.font1{
  width: 149px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Normal;
  font-weight: Normal;
  text-align: left;
  color: #333333;
  line-height: 18px;
  letter-spacing: 0px;
}
.font2{
  width: 81px;
  height: 15px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: right;
  color: #1e88ff;
  line-height: 18px;
}
.font3{
  width: 178px;
  height: 11px;
  font-size: 11px;
  font-family: SourceHanSansCN, SourceHanSansCN-Normal;
  font-weight: Normal;
  text-align: left;
  color: #999999;
  line-height: 17px;
  letter-spacing: 0px;
}
.star{
  width: 12px;
  height: 12px;
  background: #fecd13;
}
.size{
  width: 298px;
  height: 698px;
  /* opacity: 0.5; */
  background: #f3f3f3;
}
.boxsize1{
  margin-left: 10px;
  width: 293px;
  height: 324px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 5px;
}
.bnt {
  width: 300px;
  height: 5rem;
  font-size: 2rem;
  /* font-weight: bold; */
}
.control {
  width: 293px;
  height: 10rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.contro1 {
  width: 266px;
  height: 40px;
}
.contro2 {
  display: flex;
  flex-direction: row;
  width: 266px;
  height: 20px;
}
.contro3 {
  width: 293px;
  height: 5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.control2 {
  margin-left: 17px;
  font-size: 0.4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.control3 {
  margin-right: 17px;
  font-size: 0.4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.control4 {
  /* margin-right: 17px; */
  font-size: 0.4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.content {
  width: 300px;
  height: 30rem;
  display: flex;
  /* justify-content: center; */
  overflow-y:auto;
  align-items: center;
  flex-direction: column;
}
.content1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.catalogue{
   width: 293px;
   height: 36px;
   background: #eeeeee;
   border-radius: 5px 5px 0px 0px;
}
.catalogue1{
    margin-left: 10px;
    width: 56px;
    height: 35px;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #09254c;
    line-height: 35px;
    letter-spacing: 0px;
}   
.catalogue2{
  margin-top: -35px;
  margin-left: 80px;
  width: 56px;
  height: 35px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Light;
  font-weight: 300;
  text-align: left;
  color: #09254c;
  line-height: 35px;
  letter-spacing: 0px;
}   
.catalogue3{
  width: 56px;
  height: 35px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #09254c;
  line-height: 20px;
  letter-spacing: 0px;
}   
.catalogue4{
  margin-left: 105px;
  width: 56px;
  height: 35px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #09254c;
  line-height: 35px;
  letter-spacing: 0px;
}   
.text1{
   width: 300px;
   display: flex;
   flex-direction: column;
   justify-content: space-around;
   align-items: center;
   /* height: 10rem; */
   color: #333;
}

.bnt1{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    color: #fff;
    background: #3F96FC;
    width: 15rem;
    height: 3rem;
}
.fontcss{
  width: 53px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #1e88ff;
  line-height: 18px;
}
.fontcss1{
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #09254c;
  line-height: 20px;
  letter-spacing: 0px;
}
.fontcss2{
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Light;
  font-weight: 300;
  text-align: left;
  color: #09254c;
  line-height: 20px;
  letter-spacing: 0px;
}
.titlecss{
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #09254c;
  line-height: 20px;
  letter-spacing: 0px;
}
.leftcss{
  width: 48px;
  margin-left: 10px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  /* color: #666666; */
  line-height: 17px;
  letter-spacing: 0px;
}
.rightcss{
  width: 76px;
  margin-right: 10px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: right;
  /* color: #333333; */
  line-height: 17px;
  letter-spacing: 0px;
}
</style>